var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginaNoEncontrada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pagina_no_encontrada",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302.444,
    height: 485.976,
    viewBox: "0 0 302.444 485.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26421",
    "data-name": "Rect\\xE1ngulo 26421",
    width: 302.444,
    height: 485.976,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26427",
    "data-name": "Rect\\xE1ngulo 26427",
    width: 265.414,
    height: 301.828,
    transform: "translate(18.097 132.262)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23373",
    "data-name": "Grupo 23373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23372",
    "data-name": "Grupo 23372",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25499",
    "data-name": "Trazado 25499",
    d: "M2.993,470.464v8.872H0v-22.12H8.462a7.8,7.8,0,0,1,5.508,1.823,6.861,6.861,0,0,1,0,9.617,7.842,7.842,0,0,1-5.508,1.808Zm0-2.34H8.462a4.335,4.335,0,0,0,3.357-1.208,4.331,4.331,0,0,0,1.11-3.046,4.4,4.4,0,0,0-1.117-3.069,4.3,4.3,0,0,0-3.35-1.231H2.993Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25500",
    "data-name": "Trazado 25500",
    d: "M29.306,479.337q-.15-.744-.235-1.314a9.56,9.56,0,0,1-.1-1.147,6.971,6.971,0,0,1-2.179,1.983,5.586,5.586,0,0,1-2.895.8,5.374,5.374,0,0,1-3.912-1.314,4.836,4.836,0,0,1-1.345-3.624,4.246,4.246,0,0,1,1.908-3.684,8.9,8.9,0,0,1,5.172-1.329h3.251v-1.626a3.019,3.019,0,0,0-.88-2.286,3.463,3.463,0,0,0-2.493-.844,3.617,3.617,0,0,0-2.354.73,2.187,2.187,0,0,0-.9,1.747l-2.84.03-.031-.091a3.933,3.933,0,0,1,1.679-3.281,6.954,6.954,0,0,1,4.611-1.49,6.786,6.786,0,0,1,4.5,1.421,5.034,5.034,0,0,1,1.7,4.095v7.915a15.618,15.618,0,0,0,.09,1.7,8.842,8.842,0,0,0,.335,1.61Zm-4.967-2.188a5.326,5.326,0,0,0,2.932-.835,3.969,3.969,0,0,0,1.7-1.914v-2.675H25.615a4.358,4.358,0,0,0-2.9.912,2.729,2.729,0,0,0-1.085,2.142,2.253,2.253,0,0,0,.683,1.732,2.859,2.859,0,0,0,2.021.638m2.567-21.224H30.4l.03.091-4.087,3.95H24.095Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25501",
    "data-name": "Trazado 25501",
    d: "M35.778,471.422a10.963,10.963,0,0,1,1.694-6.4,5.443,5.443,0,0,1,4.733-2.431,5.773,5.773,0,0,1,2.75.63,5.541,5.541,0,0,1,1.99,1.816l.364-2.142h2.386v16.529a6.273,6.273,0,0,1-1.839,4.855,7.553,7.553,0,0,1-5.3,1.693,11.158,11.158,0,0,1-2.56-.326,10.018,10.018,0,0,1-2.423-.889l.456-2.325a8.617,8.617,0,0,0,2.089.738,10.746,10.746,0,0,0,2.408.28,4.363,4.363,0,0,0,3.183-.995,4.125,4.125,0,0,0,.995-3.031V477.56a5.3,5.3,0,0,1-1.93,1.564,6,6,0,0,1-2.6.532,5.62,5.62,0,0,1-4.7-2.18,9.083,9.083,0,0,1-1.694-5.735Zm2.993.319a6.979,6.979,0,0,0,1.018,3.98,3.532,3.532,0,0,0,3.145,1.5,3.96,3.96,0,0,0,2.264-.615,4.672,4.672,0,0,0,1.5-1.74V467.3a4.655,4.655,0,0,0-1.5-1.663,3.95,3.95,0,0,0-2.234-.615A3.409,3.409,0,0,0,39.8,466.8a9.184,9.184,0,0,0-1.025,4.619Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25502",
    "data-name": "Trazado 25502",
    d: "M57.23,458.69H54.238v-3.054H57.23Zm0,20.647H54.238V462.9H57.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25503",
    "data-name": "Trazado 25503",
    d: "M64.509,462.9l.213,2.446a5.974,5.974,0,0,1,2.058-2.029,5.506,5.506,0,0,1,2.819-.721,5.369,5.369,0,0,1,4.117,1.557,6.841,6.841,0,0,1,1.458,4.809v10.376H72.181V469.021a4.44,4.44,0,0,0-.859-3.084,3.436,3.436,0,0,0-2.62-.912,4.644,4.644,0,0,0-2.347.554,4.02,4.02,0,0,0-1.527,1.558v12.2H61.835V462.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25504",
    "data-name": "Trazado 25504",
    d: "M89.622,479.337c-.1-.5-.18-.935-.236-1.314a9.767,9.767,0,0,1-.1-1.147,6.96,6.96,0,0,1-2.18,1.982,5.572,5.572,0,0,1-2.894.8,5.377,5.377,0,0,1-3.913-1.314,4.835,4.835,0,0,1-1.344-3.624,4.244,4.244,0,0,1,1.907-3.684,8.9,8.9,0,0,1,5.173-1.329h3.251v-1.626a3.016,3.016,0,0,0-.881-2.286,3.462,3.462,0,0,0-2.492-.844,3.613,3.613,0,0,0-2.355.73,2.188,2.188,0,0,0-.9,1.747l-2.841.03-.03-.091a3.93,3.93,0,0,1,1.678-3.281,6.956,6.956,0,0,1,4.612-1.49,6.79,6.79,0,0,1,4.5,1.421,5.033,5.033,0,0,1,1.7,4.094v7.916a15.365,15.365,0,0,0,.091,1.7,8.757,8.757,0,0,0,.335,1.61Zm-4.968-2.188a5.329,5.329,0,0,0,2.933-.835,3.971,3.971,0,0,0,1.7-1.915v-2.674H85.93a4.354,4.354,0,0,0-2.894.912,2.727,2.727,0,0,0-1.086,2.142,2.253,2.253,0,0,0,.683,1.732,2.861,2.861,0,0,0,2.021.638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25505",
    "data-name": "Trazado 25505",
    d: "M107.033,462.9l.213,2.446a5.974,5.974,0,0,1,2.058-2.029,5.505,5.505,0,0,1,2.819-.721,5.369,5.369,0,0,1,4.117,1.557,6.841,6.841,0,0,1,1.458,4.809v10.376h-2.993V469.021a4.44,4.44,0,0,0-.859-3.084,3.436,3.436,0,0,0-2.62-.912,4.644,4.644,0,0,0-2.347.554,4.02,4.02,0,0,0-1.527,1.558v12.2h-2.993V462.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25506",
    "data-name": "Trazado 25506",
    d: "M121.345,470.966a9.049,9.049,0,0,1,1.975-6.009,6.623,6.623,0,0,1,5.363-2.363,6.69,6.69,0,0,1,5.4,2.355,9.023,9.023,0,0,1,1.983,6.017v.334a9.012,9.012,0,0,1-1.975,6.017,7.354,7.354,0,0,1-10.765-.008,9,9,0,0,1-1.982-6.009Zm2.993.334a7.792,7.792,0,0,0,1.1,4.315,3.978,3.978,0,0,0,6.525,0,7.759,7.759,0,0,0,1.108-4.315v-.334a7.738,7.738,0,0,0-1.116-4.3,3.661,3.661,0,0,0-3.274-1.717,3.61,3.61,0,0,0-3.243,1.717,7.811,7.811,0,0,0-1.1,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25507",
    "data-name": "Trazado 25507",
    d: "M154.268,479.656a6.958,6.958,0,0,1-5.523-2.264,8.715,8.715,0,0,1-1.982-5.956v-.668a8.522,8.522,0,0,1,2.044-5.857,6.4,6.4,0,0,1,4.99-2.317,5.964,5.964,0,0,1,4.945,2.051,8.45,8.45,0,0,1,1.649,5.454v1.58H149.877l-.045.077a6.787,6.787,0,0,0,1.094,4.018,3.821,3.821,0,0,0,3.342,1.542,7.53,7.53,0,0,0,2.667-.433,5.938,5.938,0,0,0,1.967-1.193l1.169,1.945a7.194,7.194,0,0,1-2.324,1.436,9.258,9.258,0,0,1-3.479.585m-.471-14.707a3.254,3.254,0,0,0-2.59,1.208,5.728,5.728,0,0,0-1.254,3.092l.031.075H157.4v-.243a4.79,4.79,0,0,0-.881-2.962,3.185,3.185,0,0,0-2.72-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25508",
    "data-name": "Trazado 25508",
    d: "M166.423,462.9l.213,2.446a5.974,5.974,0,0,1,2.058-2.029,5.506,5.506,0,0,1,2.819-.721,5.369,5.369,0,0,1,4.117,1.557,6.841,6.841,0,0,1,1.458,4.809v10.376H174.1V469.021a4.44,4.44,0,0,0-.859-3.084,3.436,3.436,0,0,0-2.62-.912,4.644,4.644,0,0,0-2.347.554,4.02,4.02,0,0,0-1.527,1.558v12.2h-2.993V462.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25509",
    "data-name": "Trazado 25509",
    d: "M187.965,477.316a3.517,3.517,0,0,0,2.416-.919,2.907,2.907,0,0,0,1.033-2.256h2.7l.046.091a4.721,4.721,0,0,1-1.823,3.775,6.968,6.968,0,0,1-9.724-.706,9.09,9.09,0,0,1-1.883-5.865V470.8a9.047,9.047,0,0,1,1.891-5.841,6.447,6.447,0,0,1,5.34-2.363,6.2,6.2,0,0,1,4.505,1.7,5.4,5.4,0,0,1,1.694,4.179l-.03.091h-2.72a3.628,3.628,0,0,0-.979-2.56,3.228,3.228,0,0,0-2.47-1.056,3.457,3.457,0,0,0-3.213,1.709,8,8,0,0,0-1.011,4.14v.638a8.155,8.155,0,0,0,.995,4.178,3.456,3.456,0,0,0,3.229,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25510",
    "data-name": "Trazado 25510",
    d: "M197.021,470.966A9.049,9.049,0,0,1,199,464.957a6.623,6.623,0,0,1,5.363-2.363,6.69,6.69,0,0,1,5.4,2.355,9.023,9.023,0,0,1,1.983,6.017v.334a9.012,9.012,0,0,1-1.975,6.017A7.354,7.354,0,0,1,199,477.309a9,9,0,0,1-1.982-6.009Zm2.993.334a7.792,7.792,0,0,0,1.1,4.315,3.978,3.978,0,0,0,6.525,0,7.759,7.759,0,0,0,1.108-4.315v-.334a7.738,7.738,0,0,0-1.116-4.3,3.661,3.661,0,0,0-3.274-1.717,3.61,3.61,0,0,0-3.243,1.717,7.811,7.811,0,0,0-1.1,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25511",
    "data-name": "Trazado 25511",
    d: "M218.078,462.9l.213,2.446a5.974,5.974,0,0,1,2.058-2.029,5.506,5.506,0,0,1,2.819-.721,5.369,5.369,0,0,1,4.117,1.557,6.841,6.841,0,0,1,1.458,4.809v10.376H225.75V469.021a4.44,4.44,0,0,0-.859-3.084,3.436,3.436,0,0,0-2.62-.912,4.644,4.644,0,0,0-2.347.554,4.02,4.02,0,0,0-1.527,1.558v12.2H215.4V462.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25512",
    "data-name": "Trazado 25512",
    d: "M237.251,458.933V462.9h3.115v2.218h-3.115V475.1a2.236,2.236,0,0,0,.479,1.626A1.735,1.735,0,0,0,239,477.2a2.757,2.757,0,0,0,.577-.069,4.234,4.234,0,0,0,.531-.144l.411,2.051a2.642,2.642,0,0,1-.988.448,4.957,4.957,0,0,1-1.291.175,3.878,3.878,0,0,1-2.9-1.1,4.787,4.787,0,0,1-1.078-3.457v-9.982h-2.613V462.9h2.613v-3.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25513",
    "data-name": "Trazado 25513",
    d: "M251.351,465.542l-1.534-.091a3.426,3.426,0,0,0-2,.562,3.6,3.6,0,0,0-1.253,1.58v11.744h-2.993V462.9h2.674l.288,2.4a5.7,5.7,0,0,1,1.724-1.99,4.036,4.036,0,0,1,2.363-.715,3.753,3.753,0,0,1,.638.053,4.257,4.257,0,0,1,.5.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25514",
    "data-name": "Trazado 25514",
    d: "M264.568,479.337c-.1-.5-.18-.935-.236-1.314a9.766,9.766,0,0,1-.1-1.147,6.96,6.96,0,0,1-2.18,1.982,5.572,5.572,0,0,1-2.894.8,5.377,5.377,0,0,1-3.913-1.314,4.835,4.835,0,0,1-1.344-3.624,4.244,4.244,0,0,1,1.907-3.684,8.9,8.9,0,0,1,5.173-1.329h3.251v-1.626a3.016,3.016,0,0,0-.881-2.286,3.462,3.462,0,0,0-2.492-.844,3.613,3.613,0,0,0-2.355.73,2.188,2.188,0,0,0-.9,1.747l-2.841.03-.03-.091a3.93,3.93,0,0,1,1.678-3.281,6.956,6.956,0,0,1,4.612-1.49,6.79,6.79,0,0,1,4.5,1.421,5.033,5.033,0,0,1,1.7,4.094v7.916a15.365,15.365,0,0,0,.091,1.7,8.757,8.757,0,0,0,.335,1.61Zm-4.968-2.188a5.329,5.329,0,0,0,2.933-.835,3.971,3.971,0,0,0,1.7-1.915v-2.674h-3.358a4.354,4.354,0,0,0-2.894.912,2.727,2.727,0,0,0-1.086,2.142,2.253,2.253,0,0,0,.683,1.732,2.861,2.861,0,0,0,2.021.638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25515",
    "data-name": "Trazado 25515",
    d: "M270.889,471.422a10.97,10.97,0,0,1,1.693-6.4,5.458,5.458,0,0,1,4.748-2.431,5.893,5.893,0,0,1,2.56.531,5.25,5.25,0,0,1,1.907,1.55v-9.039h2.993v23.7H282.5l-.456-2.081a5.344,5.344,0,0,1-1.99,1.793,5.961,5.961,0,0,1-2.75.607,5.643,5.643,0,0,1-4.71-2.18,9.055,9.055,0,0,1-1.7-5.735Zm2.992.319a6.976,6.976,0,0,0,1.019,3.988,3.552,3.552,0,0,0,3.16,1.5,3.96,3.96,0,0,0,2.248-.608,4.528,4.528,0,0,0,1.489-1.7v-7.673a4.61,4.61,0,0,0-1.5-1.617,3.953,3.953,0,0,0-2.21-.6,3.421,3.421,0,0,0-3.183,1.777,9.184,9.184,0,0,0-1.026,4.619Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25516",
    "data-name": "Trazado 25516",
    d: "M299.36,479.337c-.1-.5-.18-.935-.236-1.314a9.772,9.772,0,0,1-.1-1.147,6.96,6.96,0,0,1-2.18,1.982,5.572,5.572,0,0,1-2.894.8,5.377,5.377,0,0,1-3.913-1.314,4.835,4.835,0,0,1-1.344-3.624,4.244,4.244,0,0,1,1.907-3.684,8.9,8.9,0,0,1,5.173-1.329h3.251v-1.626a3.016,3.016,0,0,0-.881-2.286,3.462,3.462,0,0,0-2.492-.844,3.613,3.613,0,0,0-2.355.73,2.188,2.188,0,0,0-.9,1.747l-2.841.03-.03-.091a3.93,3.93,0,0,1,1.678-3.281,6.956,6.956,0,0,1,4.612-1.49,6.79,6.79,0,0,1,4.5,1.421,5.033,5.033,0,0,1,1.7,4.094v7.916a15.373,15.373,0,0,0,.091,1.7,8.757,8.757,0,0,0,.335,1.61Zm-4.968-2.188a5.329,5.329,0,0,0,2.933-.835,3.971,3.971,0,0,0,1.7-1.915v-2.674h-3.358a4.354,4.354,0,0,0-2.894.912,2.727,2.727,0,0,0-1.086,2.142,2.253,2.253,0,0,0,.683,1.732,2.861,2.861,0,0,0,2.021.638"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23375",
    "data-name": "Grupo 23375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23374",
    "data-name": "Grupo 23374",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25517",
    "data-name": "Trazado 25517",
    d: "M36.412,264.587c-4.018,5.606-9.355,10.59-11.175,17.242-2.565,9.373,3.846,20.226,13.293,22.5,2.791.673,5.821.716,8.277,2.2,4.045,2.45,5.069,8.15,3.566,12.633s-4.923,8.02-8.271,11.36c-7.643,7.622-15.98,16.183-16.447,26.967-.413,9.555,5.891,18.494,14.094,23.41s18.015,6.4,27.574,6.706c7.742.248,15.584-.224,23.01-2.427,18.073-5.36,31.987-20.7,39.322-38.063s8.842-36.637,8.53-55.485c-.275-16.622-1.964-33.511-8.34-48.863s-17.973-29.126-33.486-35.116c-12.018-4.639-42.386-10.468-47.158,5.079-5.484,17.865-.829,35.165-12.789,51.852",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25518",
    "data-name": "Trazado 25518",
    d: "M233.214,234.869c5.55,4.094,12.163,7.191,15.945,12.958,5.329,8.126,2.575,20.427-5.71,25.505-2.448,1.5-5.317,2.475-7.2,4.646-3.094,3.577-2.312,9.315.5,13.117s7.155,6.113,11.369,8.257c9.62,4.9,20.19,10.471,23.958,20.586,3.338,8.962.1,19.409-6.193,26.615s-15.166,11.64-24.165,14.878c-7.289,2.622-14.894,4.589-22.638,4.783-18.845.47-36.809-9.832-49.139-24.092s-19.7-32.128-25.216-50.155c-4.861-15.9-8.46-32.485-7.126-49.055s8.122-33.247,21.034-43.727c10-8.117,37.1-23.021,46.428-9.7,10.722,15.3,11.626,33.2,28.147,45.386",
    fill: "#633c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25519",
    "data-name": "Trazado 25519",
    d: "M150.945,217.335A50.834,50.834,0,1,1,100.111,166.5a50.834,50.834,0,0,1,50.834,50.834",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25520",
    "data-name": "Trazado 25520",
    d: "M167.911,194.386a50.834,50.834,0,1,1-50.834-50.834,50.834,50.834,0,0,1,50.834,50.834",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25521",
    "data-name": "Trazado 25521",
    d: "M195.041,187.205a50.834,50.834,0,1,1-50.834-50.834,50.834,50.834,0,0,1,50.834,50.834",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25522",
    "data-name": "Trazado 25522",
    d: "M213.642,197.723a50.834,50.834,0,1,1-50.834-50.834,50.834,50.834,0,0,1,50.834,50.834",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25523",
    "data-name": "Trazado 25523",
    d: "M213.99,212.059c12.133,41.888-8.138,84.565-45.276,95.323S91.634,292.9,79.5,251.014s8.138-84.565,45.276-95.322,77.08,14.479,89.213,56.367",
    fill: "#fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25524",
    "data-name": "Trazado 25524",
    d: "M91.711,242.495c1.822,12.107-4.45,23.089-14.008,24.527S58.919,259.812,57.1,247.7s4.45-23.088,14.009-24.527,18.784,7.211,20.606,19.318",
    fill: "#fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25525",
    "data-name": "Trazado 25525",
    d: "M119.59,257.113a27.431,27.431,0,0,1-13.983-4.359,1.3,1.3,0,0,1,1.46-2.143c.086.058,8.681,5.8,17.149,3.247,5.329-1.6,9.564-6.149,12.589-13.51a1.3,1.3,0,1,1,2.4.985c-3.339,8.128-8.137,13.179-14.26,15.014a18.594,18.594,0,0,1-5.353.766",
    fill: "#6d3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25526",
    "data-name": "Trazado 25526",
    d: "M180.874,234.332a27.427,27.427,0,0,1-13.983-4.359,1.3,1.3,0,0,1,1.459-2.143c.086.058,8.683,5.795,17.149,3.247,5.328-1.6,9.564-6.149,12.588-13.51a1.3,1.3,0,1,1,2.4.985c-3.34,8.128-8.136,13.179-14.259,15.014a18.6,18.6,0,0,1-5.353.766",
    fill: "#6d3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25527",
    "data-name": "Trazado 25527",
    d: "M152.243,279.15a1.3,1.3,0,0,1-1.234-1.7c2.717-8.356,7.119-13.754,13.086-16.046,9.416-3.617,19.142,1.887,19.552,2.123a1.3,1.3,0,1,1-1.294,2.246c-.111-.063-9.1-5.118-17.344-1.942-5.193,2-9.074,6.853-11.533,14.421a1.3,1.3,0,0,1-1.233.9",
    fill: "#6d3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25528",
    "data-name": "Trazado 25528",
    d: "M166.989,246.936c1.088,2.822-1.98,6.632-6.852,8.509s-9.7,1.112-10.789-1.71,1.98-6.632,6.851-8.509,9.7-1.112,10.79,1.71",
    fill: "#f2b5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25529",
    "data-name": "Trazado 25529",
    d: "M205.371,248.326a10.959,10.959,0,1,1-10.959-10.959,10.959,10.959,0,0,1,10.959,10.959",
    fill: "#f2b5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25530",
    "data-name": "Trazado 25530",
    d: "M138,275.075a10.958,10.958,0,1,1-10.959-10.959A10.959,10.959,0,0,1,138,275.075",
    fill: "#f2b5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25531",
    "data-name": "Trazado 25531",
    d: "M158.813,195.265c4.692,5.3,17.206,16.091,35.877,7.4a.639.639,0,0,0-.316-1.208,62.849,62.849,0,0,1-34.845-7.18.618.618,0,0,0-.716.987",
    fill: "#b37def"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25532",
    "data-name": "Trazado 25532",
    d: "M129.751,203.314c-.661,7.05-4.4,23.143-24.606,27.139a.639.639,0,0,1-.456-1.162,62.851,62.851,0,0,0,23.9-26.352.618.618,0,0,1,1.16.375",
    fill: "#b37def"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25533",
    "data-name": "Trazado 25533",
    d: "M66.852,252.28a1.3,1.3,0,0,1-1.25-.958c-1.4-5.161-1.182-9.361.643-12.485a9.013,9.013,0,0,1,5.1-4.142,1.3,1.3,0,1,1,.638,2.514c-.276.075-6.969,2.035-3.881,13.435a1.3,1.3,0,0,1-.912,1.591,1.335,1.335,0,0,1-.34.045",
    fill: "#6d3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25534",
    "data-name": "Trazado 25534",
    d: "M124.777,153.772s57.689,38.327,80.594,38.081c0,0-1.577-26.358-30.073-38.081s-50.521,0-50.521,0",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25535",
    "data-name": "Trazado 25535",
    d: "M129.218,145.369S58.961,166.5,58.961,230.807c0,0,40.313,3.5,62.507-27.063s7.75-58.375,7.75-58.375",
    fill: "#7a4aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26422",
    "data-name": "Rect\\xE1ngulo 26422",
    width: 35.763,
    height: 26.138,
    transform: "translate(127.045 303.685)",
    fill: "#fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25536",
    "data-name": "Trazado 25536",
    d: "M208.327,440.4H90.622c-14.32,0-25.929-26.073-25.929-40.393V356.1a25.929,25.929,0,0,1,25.929-25.929h117.7A25.929,25.929,0,0,1,234.256,356.1V400.01c0,14.32-11.609,40.393-25.929,40.393",
    fill: "#74d7e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26423",
    "data-name": "Rect\\xE1ngulo 26423",
    width: 41.212,
    height: 35.089,
    transform: "translate(57.854 384.104) rotate(-76.799)",
    fill: "#74d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25537",
    "data-name": "Trazado 25537",
    d: "M83.9,441.19l-34.161-8.013,9.411-54.587L93.309,386.6Z",
    fill: "#fdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26424",
    "data-name": "Rect\\xE1ngulo 26424",
    width: 35.088,
    height: 42.393,
    transform: "translate(196.953 351.994) rotate(-13.201)",
    fill: "#74d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25538",
    "data-name": "Trazado 25538",
    d: "M215.1,440.719l34.161-8.013-9.411-54.587-34.162,8.013Z",
    fill: "#fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25539",
    "data-name": "Trazado 25539",
    d: "M216.689,442.04,82.786,440l12.336-71.6,2.555.44L85.856,437.457l127.66,1.941-14.128-70.519,2.542-.509Z",
    fill: "#2cc8d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26425",
    "data-name": "Rect\\xE1ngulo 26425",
    width: 35.089,
    height: 2.594,
    transform: "translate(205.395 384.874) rotate(-13.217)",
    fill: "#2cc8d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26426",
    "data-name": "Rect\\xE1ngulo 26426",
    width: 2.594,
    height: 35.089,
    transform: "translate(58.851 379.852) rotate(-76.799)",
    fill: "#2cc8d5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23377",
    "data-name": "Grupo 23377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23376",
    "data-name": "Grupo 23376",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25540",
    "data-name": "Trazado 25540",
    d: "M128.309,1.394A49.81,49.81,0,1,0,178.166,51.2a49.89,49.89,0,0,0-49.857-49.81m0,92.577A42.768,42.768,0,1,1,171.124,51.2a42.839,42.839,0,0,1-42.815,42.767",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25541",
    "data-name": "Trazado 25541",
    d: "M128.338,22.673a16.8,16.8,0,0,0-16.785,16.783,3.521,3.521,0,1,0,7.042,0,9.743,9.743,0,1,1,12.811,9.25l-.321.087a8.554,8.554,0,0,0-6.268,8.228v3.572a3.521,3.521,0,1,0,7.042,0V57.021a1.489,1.489,0,0,1,1.084-1.435l.4-.108c.054-.015.106-.03.157-.047a16.785,16.785,0,0,0-5.158-32.758",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25542",
    "data-name": "Trazado 25542",
    d: "M128.338,70.423a3.521,3.521,0,0,0-3.521,3.521v3.129a3.521,3.521,0,1,0,7.042,0V73.944a3.521,3.521,0,0,0-3.521-3.521",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25543",
    "data-name": "Trazado 25543",
    d: "M210.813,124.549l-41.7-41.416a51.037,51.037,0,1,0-6.591,6.655l41.69,41.407a4.683,4.683,0,0,0,6.6-6.646m-80.994-32.18a41.5,41.5,0,1,1,41.5-41.5,41.548,41.548,0,0,1-41.5,41.5",
    fill: "#26acb7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginaNoEncontrada);
export default __webpack_public_path__ + "static/media/Pagina_no_encontrada.d6900daf9e5209f36cf3b90f05f1230e.svg";
export { ForwardRef as ReactComponent };